<template>
  <div class="px-8 py-1">
    <v-container grid-list-xl fluid class="px-0">
      <v-flex xs12 mb-3>
        <h2 class="darkblue--text fs-16 lh-16 font-weight-700">
          Ad hoc Configuration
        </h2>
        <v-breadcrumbs class="px-0" :items="breadcrumbs"></v-breadcrumbs>
      </v-flex>
      <v-card>
        <v-card-title>
          <v-flex xs9> </v-flex>
          <v-flex xs3 class="text-right">
            <v-icon @click="getData">refresh</v-icon>
          </v-flex>
        </v-card-title>
        <v-card-text>
          <v-flex xs12>
            <v-row class="px-5">
              <v-flex xs12 class="pl-2">
                <label class="subtitle-1 font-weight-black lightblack--text">
                  Activate
                </label>
                <v-switch v-model="item.config" inset color="primary">
                </v-switch>
              </v-flex>
            </v-row>
          </v-flex>
        </v-card-text>
        <v-card-actions class="text-right">
          <v-spacer></v-spacer>
          <v-flex xs2 class="mb-5 mr-3">
            <v-btn
              id="saveBtn"
              color="blue darken-2"
              class="white--text"
              block
              @click="save()"
            >
              Save
            </v-btn>
          </v-flex>
        </v-card-actions>
      </v-card>
    </v-container>
    <progress-dialog :show="progressDialogLoading" text="Please wait">
    </progress-dialog>
  </div>
</template>

<script>
import ProgressDialog from '../../../components/progress_dialog';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import ACLMixin from '../../../mixins/ACLMixin';

export default {
  components: { 'progress-dialog': ProgressDialog },
  mixins: [ACLMixin],
  data() {
    return {
      progressDialogLoading: true,
      breadcrumbs: [
        {
          text: 'Configuration',
          disabled: true,
          href: 'breadcrumbs_dashboard'
        },
        {
          text: 'Ad hoc',
          disabled: true,
          href: 'breadcrumbs_link_1'
        }
      ],
      item: {}
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.progressDialogLoading = true;
      this.$store
        .dispatch('configuration/getAdhoc')
        .then(data => {
          this.progressDialogLoading = false;
          if (data.code === 200) {
            this.item = data.data;
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          this.progressDialogLoading = false;
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
        });
    },
    save() {
      Swal.fire({
        title: '',
        text: 'Are you sure want to update config Ad hoc?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No'
      }).then(result => {
        if (result.value) {
          this.updateAdhoc();
        }
      });
    },
    updateAdhoc() {
      this.progressDialogLoading = true;
      let params = {
        id: this.item.id,
        config: this.item.config
      };
      this.$store
        .dispatch('configuration/updateAdhoc', params)
        .then(data => {
          this.progressDialogLoading = false;
          if (data.code === 200) {
            Swal.fire({
              title: 'Success!',
              text: `${data.message.text_en}`,
              type: 'success',
              showCancelButton: false,
              confirmButtonText: 'OK'
            }).then(result => {
              if (result.value) {
                this.getData();
              }
            });
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          this.progressDialogLoading = false;
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
        });
    }
  }
};
</script>
